// Hook taken from here:
// https://brianm.me/posts/react-router-search-params/#use-search-params-custom-hook

import { useLocationLegacy as useLocation } from '@leagueplatform/routing';
import { useMemo } from 'react';

interface ReadOnlyURLSearchParams extends URLSearchParams {
  append: never;
  set: never;
  delete: never;
  sort: never;
}

export function useSearchParams(param: string): string | null;
export function useSearchParams(): ReadOnlyURLSearchParams;
export function useSearchParams(param?: string) {
  const { search } = useLocation();

  const params = useMemo(
    () => new URLSearchParams(search) as ReadOnlyURLSearchParams,
    [search],
  );

  if (param) {
    return params.get(param);
  }

  return params;
}
